module.exports = __webpack_public_path__ + "img/Frame4453.ba1399b0.png";